import type { FetchError } from '@execonline-inc/fetch.private';
import type { UseFetch } from '@execonline-inc/react-hooks.private';
import { currentUserStore } from '../../../../../../../CurrentUserStore';
import { useFetchResource, useFindLinkByR } from '../../../../../../../Fetch';
import { declareEndpoint, type MissingLinkError } from '../../../../../../../Links';
import * as Resourceable from '../../../../../../../Resourceable';

export type State = UseFetch.State<
  FetchError | MissingLinkError,
  Resourceable.ParsedResponse<'/learning_collection_template/:id', 'get'>
>;

interface UseBuilderResult {
  state: State;
}

export const useBuilder = (id: string): UseBuilderResult => {
  const link = useFindLinkByR(
    { rel: 'edit-learning-collection-template-v2', method: 'get' },
    currentUserStore.links,
  );

  const state = useFetchResource(
    link
      .map((link) => ({ ...link, href: link.href.replace(`{learning_collection_id}`, `${id}`) }))
      .map(declareEndpoint('/learning_collection_template/:id')),
  );

  return { state };
};
